module.exports = __webpack_public_path__ + "img/2615.ca4ddcd.svg";